// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// Success Image element
const successElement = document.createElement('img');
successElement.className = 'status-img';
successElement.src = '/assets/success.svg';

// Error Image element
const errorElement = document.createElement('img');
errorElement.className = 'status-img';
errorElement.src = '/assets/error.svg';

// Endpoint to get report config
const reportUrl = 'https://aka.ms/CaptureViewsReportEmbedConfig';
//const reportUrl = 'https://api.powerbi.com/v1.0/myorg/reports/592b64e5-e544-4b5a-bef6-6793697a0f6b'
const errorClass = 'error';
const successClass = 'success';

//PowerBi Url
const powerbiUrl="https://api.powerbi.com";
const powerbiEndpointScopes=['https://analysis.windows.net/powerbi/api/Report.Read.All', 'https://analysis.windows.net/powerbi/api/Dataset.Read.All']

// To show / hide the report container
const hidden = 'hidden';

// To position the display message
const position = 'position';

export { errorClass, errorElement, hidden, position, reportUrl, successClass, successElement,powerbiUrl,powerbiEndpointScopes};